/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeReparationDto } from '../models/type-reparation-dto';


/**
 * Fonction de gestion des types de réparations
 */
@Injectable({
  providedIn: 'root',
})
export class TypesReparationsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeReparationGetList
   */
  static readonly TypeReparationGetListPath = '/api/types-reparations/list';

  /**
   * Renvoie la liste des types de réparations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeReparationGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeReparationGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeReparationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesReparationsService.TypeReparationGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeReparationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types de réparations.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeReparationGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeReparationGetList(params?: {
  }): Observable<Array<TypeReparationDto>> {

    return this.typeReparationGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeReparationDto>>) => r.body as Array<TypeReparationDto>)
    );
  }

  /**
   * Path part for operation typeReparationLoadList
   */
  static readonly TypeReparationLoadListPath = '/api/types-reparations/load-list';

  /**
   * Renvoie la liste des types de réparations (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeReparationLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeReparationLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesReparationsService.TypeReparationLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types de réparations (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeReparationLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeReparationLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeReparationLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeReparationGet
   */
  static readonly TypeReparationGetPath = '/api/types-reparations/{id}';

  /**
   * Renvoie le type de réparation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeReparationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeReparationGet$Response(params: {

    /**
     * Identifiant du type de réparation
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeReparationDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesReparationsService.TypeReparationGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeReparationDto>;
      })
    );
  }

  /**
   * Renvoie le type de réparation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeReparationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeReparationGet(params: {

    /**
     * Identifiant du type de réparation
     */
    id: number;
  }): Observable<TypeReparationDto> {

    return this.typeReparationGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeReparationDto>) => r.body as TypeReparationDto)
    );
  }

  /**
   * Path part for operation typeReparationPut
   */
  static readonly TypeReparationPutPath = '/api/types-reparations/{id}';

  /**
   * Met à jour le type de réparation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeReparationPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeReparationPut$Response(params: {

    /**
     * Identifiant du type de réparation à mettre à jour
     */
    id: number;

    /**
     * Type de réparation
     */
    body: TypeReparationDto
  }): Observable<StrictHttpResponse<TypeReparationDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesReparationsService.TypeReparationPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeReparationDto>;
      })
    );
  }

  /**
   * Met à jour le type de réparation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeReparationPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeReparationPut(params: {

    /**
     * Identifiant du type de réparation à mettre à jour
     */
    id: number;

    /**
     * Type de réparation
     */
    body: TypeReparationDto
  }): Observable<TypeReparationDto> {

    return this.typeReparationPut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeReparationDto>) => r.body as TypeReparationDto)
    );
  }

  /**
   * Path part for operation typeReparationDelete
   */
  static readonly TypeReparationDeletePath = '/api/types-reparations/{id}';

  /**
   * Supprime le type de réparation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeReparationDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeReparationDelete$Response(params: {

    /**
     * Identifiant du type de réparation à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesReparationsService.TypeReparationDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type de réparation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeReparationDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeReparationDelete(params: {

    /**
     * Identifiant du type de réparation à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeReparationDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeReparationPost
   */
  static readonly TypeReparationPostPath = '/api/types-reparations';

  /**
   * Crée le type de réparation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeReparationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeReparationPost$Response(params: {

    /**
     * Type de réparation
     */
    body: TypeReparationDto
  }): Observable<StrictHttpResponse<TypeReparationDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesReparationsService.TypeReparationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeReparationDto>;
      })
    );
  }

  /**
   * Crée le type de réparation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeReparationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeReparationPost(params: {

    /**
     * Type de réparation
     */
    body: TypeReparationDto
  }): Observable<TypeReparationDto> {

    return this.typeReparationPost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeReparationDto>) => r.body as TypeReparationDto)
    );
  }

  /**
   * Path part for operation typeReparationDesactivate
   */
  static readonly TypeReparationDesactivatePath = '/api/types-reparations/{id}/desactivate';

  /**
   * Désactive le type de réparation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeReparationDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeReparationDesactivate$Response(params: {

    /**
     * Identifiant du type de réparation à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeReparationDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesReparationsService.TypeReparationDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le type de réparation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeReparationDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeReparationDesactivate(params: {

    /**
     * Identifiant du type de réparation à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeReparationDto
  }): Observable<number> {

    return this.typeReparationDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
